export const Policy = {
	title: null,
	content: null,
};
